import * as React from 'react';

import { useIsMobileDevice } from '../../../../hooks';
import cn from 'classnames';
import * as styles from './styles.css';
import { Button } from '@cian/ui-kit';

interface IRosbankPilotBannerProps {
  url: string;
  onClick: () => void;
}

export const RosbankPilotBanner = ({ url, onClick }: IRosbankPilotBannerProps) => {
  const isMobile = useIsMobileDevice();

  return (
    <div className={cn(styles['container'], isMobile && styles['container-mobile'])} data-testid="rosbank-pilot-banner">
      <a
        href={`${url}?cian_source=new_ad_banner`}
        target="_blank"
        rel="noreferrer"
        data-testid="rosbank-pilot-banner-inner-wrapper"
        onClick={onClick}
        className={cn(styles['wrapper'], isMobile && styles['wrapper-mobile'])}
      >
        <div className={cn(styles['title'], isMobile && styles['title-mobile'])}>
          Купите новую квартиру, пока старая продается
        </div>
        <div className={cn(styles['button'], isMobile && styles['button-mobile'])}>
          <Button size="M" theme="fill_primary">
            Узнать как
          </Button>
        </div>
      </a>
    </div>
  );
};

RosbankPilotBanner.displayName = 'RosbankPilotBanner';
